import TiptapTable from '@tiptap/extension-table';
import TiptapTableCell from '@tiptap/extension-table-cell';
import TiptapTableHeader from '@tiptap/extension-table-header';
import TiptapTableRow from '@tiptap/extension-table-row';

export const Table = TiptapTable.configure({
  resizable: false,
  renderWrapper: true,
});

export const TableRow = TiptapTableRow;
export const TableCell = TiptapTableCell;
export const TableHeader = TiptapTableHeader;
